import { fr } from './fr';
import { en } from './en';

export const translations = {
  fr,
  en,
};

export const getTranslation = (language, key) => {
  return translations[language]?.[key] || key;
};

